import React from 'react'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import AlertBox from '@envato/foundation-alert-box'

import SafeInnerHtml from '../safeInnerHtml'

import styles from './alertsStream.module.css'

const AlertsStream = ({ alerts = [], hideAlert }) => {
  return (
    <div className="grid-container">
      <CSSTransitionGroup
        transitionName={{
          enter: '-animate--enter',
          enterActive: '-animate--enter-active',
          leave: '-animate--leave',
          leaveActive: '-animate--leave-active'
        }}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}
      >
        {alerts.map(({ message, type, canBeDismissed }, index) => {
          if (canBeDismissed) {
            return (
              <div
                className={styles.alertBox}
                key={index}
                data-test-selector="alert-box"
              >
                <AlertBox type={type} onDismiss={hideAlert.bind(null, message)}>
                  <SafeInnerHtml html={message} />
                </AlertBox>
              </div>
            )
          } else {
            return (
              <div
                className={styles.alertBox}
                key={index}
                data-test-selector="alert-box"
              >
                <AlertBox type={type}>
                  <SafeInnerHtml html={message} />
                </AlertBox>
              </div>
            )
          }
        })}
      </CSSTransitionGroup>
    </div>
  )
}

export default AlertsStream
